import { RoleManagementState } from '@pages/role-management/store/states/role-management.state';
import { CreateCustomRoleState } from '@pages/role-management/store/states/create-custom-role.state';
import { UpdateCustomRoleState } from '@pages/role-management/store/states/update-custom-role.state';
import { RoleNameUniqueState } from '@pages/role-management/store/states/role-name-unique.state';
import { PermissionGroupsState } from '@pages/role-management/store/states/permission-groups.state';
import { CustomRoleState } from '@pages/role-management/store/states/custom-role.state';
import { RoleUsersState } from '@pages/role-management/store/states/role-users.state';

export const roleManagementStates = [
  RoleManagementState,
  CreateCustomRoleState,
  UpdateCustomRoleState,
  RoleNameUniqueState,
  PermissionGroupsState,
  CustomRoleState,
  RoleUsersState,
];
